import { api_GET, api_GET_External, api_POST } from "./_api.js";

const cep_api =
{
    get: function (cep) {
        const promise = new Promise((resolve, reject) => {
            api_GET_External(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`).then(result => {
                if (result.data.erro)
                    reject({ message: "CEP não encontrado" });
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    },
    GeoCode: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("GeoCode/GetEndereco", json).then(result => {
                if (result.data.erro)
                    reject({ message: "CEP não encontrado" });
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    },
    GeoCodeLatLog: (lat, log) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`GeoCode/GetEnderecoLatLog/${lat}/${log}`).then(result => {
                if (result.data.erro)
                    reject({ message: "CEP não encontrado" });
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    }
}

export default cep_api
